// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ViewRoutes.module.css */

:root {
  --primary-color: #007bff;
  --secondary-color: #f8f9fa;
  --text-color: #333;
  --status-open: #007bff;
  --status-closed: #28a745;
  --status-not-delivered: #dc3545;
  --status-pending: #ffc107;
}

.RoutesDetails_dispatcherContainer__Lmf1G {
  display: flex;
  /* вместо height: 100vh: */
  height: calc(100vh - 145px);
  background-color: var(--secondary-color);
  overflow: hidden;
  z-index: 100;
}
.RoutesDetails_dispatcherSidebar__VUZ0M {
  width: 330px;
  background: white;
  padding: 20px;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
}

.RoutesDetails_dispatcherDateFilterRow__cm2mJ {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.RoutesDetails_dispatcherDateFilterRow__cm2mJ label {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 120px;
  font-size: 14px;
}

.RoutesDetails_dispatcherDateFilterRow__cm2mJ input[type="date"] {
  margin-left: 5px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  width: 100px;
  max-width: 100px;
}

.RoutesDetails_routesList__JbTlS {
  flex-grow: 1;
  overflow-y: auto;
  padding: 0;
  margin-bottom: 10px;
}

.RoutesDetails_routesList__JbTlS::-webkit-scrollbar {
  width: 6px;
}

.RoutesDetails_routesList__JbTlS::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.RoutesDetails_routeItem__JAQaF {
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
  transition: background-color 0.2s ease-in-out;
}

.RoutesDetails_selected__Bj0xZ {
  background-color: #e0e0e0;
}

.RoutesDetails_progressContainer__hFOhJ {
  width: 100%;
  height: 10px;
  background-color: #f3f3f3;
  margin: 10px 0;
  border-radius: 4px;
}

.RoutesDetails_progressBar__RAOiO {
  display: flex;
  height: 10px;
  border-radius: 4px;
  overflow: hidden;
}

.RoutesDetails_progressDelivered__3rGRd {
  background-color: rgb(40, 167, 69);
  transition: width 0.3s ease;
}

.RoutesDetails_progressInProgress__RpwaB {
  background-color: rgb(0, 123, 255);
  transition: width 0.3s ease;
}

.RoutesDetails_progressUndelivered__WWu9B {
  background-color: rgb(220, 53, 69);
  transition: width 0.3s ease;
}

.RoutesDetails_statusText__4xVzm {
  font-size: 12px;
  margin-top: 4px;
  text-align: right;
}

/* Детали маршрута */
.RoutesDetails_routeDetails__j25-M {
  flex: 1 1;
  padding: 20px;
  overflow-y: auto;
}

/* Таблица квитанций */
.RoutesDetails_dispatcherReceiptsTable__\\+3uPy {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
\\ n.RoutesDetails_dispatcherReceiptsTable__\\+3uPy th,
.RoutesDetails_dispatcherReceiptsTable__\\+3uPy td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: center;
}

.RoutesDetails_dispatcherReceiptsTable__\\+3uPy th {
  background-color: var(--primary-color);
  color: white;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}

.RoutesDetails_dispatcherReceiptsTable__\\+3uPy th:hover {
  background: #0056b3;
}

.RoutesDetails_statusSelect__3qt5Q {
  width: 100%;
  min-width: 120px;
  white-space: nowrap;
  background: transparent;
  border: none;
  color: white;
  font-weight: bold;
  cursor: pointer;
  padding: 4px 8px;
  appearance: none;
  outline: none;
  box-shadow: none;
}

.RoutesDetails_statusSelect__3qt5Q option {
  color: #333;
  background: #fff;
}

.RoutesDetails_statusSelect__3qt5Q::-ms-expand {
  display: none;
}

/* Мобильная адаптация */
@media (max-width: 768px) {
  .RoutesDetails_dispatcherContainer__Lmf1G {
    flex-direction: column;
    height: auto;
  }

  .RoutesDetails_dispatcherSidebar__VUZ0M {
    width: 100%;
    max-height: 40vh;
    box-shadow: none;
    padding: 10px;
    background: #fff;
  }

  .RoutesDetails_routesList__JbTlS {
    display: flex;
    flex-direction: column;
    gap: 5px;
    white-space: nowrap;
    padding: 10px 0;
    overflow-y: auto;
  }

  .RoutesDetails_routeItem__JAQaF {
    background: #f1f1f1;
    border-radius: 5px;
  }

  .RoutesDetails_routeDetails__j25-M {
    padding: 15px;
  }

  .RoutesDetails_dispatcherReceiptsTable__\\+3uPy {
    display: block;
    width: 100%;
    overflow-x: auto;
  }

  .RoutesDetails_dispatcherReceiptsTable__\\+3uPy thead {
    display: none;
  }

  .RoutesDetails_dispatcherReceiptsTable__\\+3uPy tbody {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .RoutesDetails_dispatcherReceiptsTable__\\+3uPy tr {
    display: flex;
    flex-direction: column;
    padding: 10px;
    background: white;
    border: 1px solid #ddd;
    border-radius: 8px;
  }

  .RoutesDetails_dispatcherReceiptsTable__\\+3uPy td {
    border: none;
    text-align: left;
    padding: 5px 0;
  }

  .RoutesDetails_dispatcherReceiptsTable__\\+3uPy td:first-child {
    font-weight: bold;
  }
}

/* Добавьте в самый конец файла ViewRoutes.module.css */

.RoutesDetails_columnSettings__Nltqw {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;              /* расстояние между чекбоксами */
  margin: 16px 0;       /* отступ от других блоков */
  align-items: center;  /* выровнять по базовой линии */
}

.RoutesDetails_columnSettings__Nltqw label {
  display: inline-flex;
  align-items: center;
  gap: 4px;          /* чуть больше пространства между чекбоксом и текстом */
  white-space: nowrap;  /* не даёт переносить текст внутри лейбла */
}`, "",{"version":3,"sources":["webpack://./src/modules/Dispatcher/RouteDetails/RoutesDetails.module.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,2BAA2B;EAC3B,wCAAwC;EACxC,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;AAC5C;AACA;;EAEE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,uDAAuD;;AAEvD;EACE,aAAa;EACb,eAAe;EACf,QAAQ,eAAe,gCAAgC;EACvD,cAAc,QAAQ,4BAA4B;EAClD,mBAAmB,GAAG,+BAA+B;AACvD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ,WAAW,uDAAuD;EAC1E,mBAAmB,GAAG,2CAA2C;AACnE","sourcesContent":["/* ViewRoutes.module.css */\r\n\r\n:root {\r\n  --primary-color: #007bff;\r\n  --secondary-color: #f8f9fa;\r\n  --text-color: #333;\r\n  --status-open: #007bff;\r\n  --status-closed: #28a745;\r\n  --status-not-delivered: #dc3545;\r\n  --status-pending: #ffc107;\r\n}\r\n\r\n.dispatcherContainer {\r\n  display: flex;\r\n  /* вместо height: 100vh: */\r\n  height: calc(100vh - 145px);\r\n  background-color: var(--secondary-color);\r\n  overflow: hidden;\r\n  z-index: 100;\r\n}\r\n.dispatcherSidebar {\r\n  width: 330px;\r\n  background: white;\r\n  padding: 20px;\r\n  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\r\n  overflow-y: auto;\r\n}\r\n\r\n.dispatcherDateFilterRow {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.dispatcherDateFilterRow label {\r\n  display: flex;\r\n  align-items: center;\r\n  flex: 1 1 auto;\r\n  min-width: 120px;\r\n  font-size: 14px;\r\n}\r\n\r\n.dispatcherDateFilterRow input[type=\"date\"] {\r\n  margin-left: 5px;\r\n  padding: 5px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  width: 100px;\r\n  max-width: 100px;\r\n}\r\n\r\n.routesList {\r\n  flex-grow: 1;\r\n  overflow-y: auto;\r\n  padding: 0;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.routesList::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.routesList::-webkit-scrollbar-thumb {\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n  border-radius: 3px;\r\n}\r\n\r\n.routeItem {\r\n  padding: 10px;\r\n  cursor: pointer;\r\n  border-bottom: 1px solid #ddd;\r\n  transition: background-color 0.2s ease-in-out;\r\n}\r\n\r\n.selected {\r\n  background-color: #e0e0e0;\r\n}\r\n\r\n.progressContainer {\r\n  width: 100%;\r\n  height: 10px;\r\n  background-color: #f3f3f3;\r\n  margin: 10px 0;\r\n  border-radius: 4px;\r\n}\r\n\r\n.progressBar {\r\n  display: flex;\r\n  height: 10px;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n}\r\n\r\n.progressDelivered {\r\n  background-color: rgb(40, 167, 69);\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.progressInProgress {\r\n  background-color: rgb(0, 123, 255);\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.progressUndelivered {\r\n  background-color: rgb(220, 53, 69);\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.statusText {\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n  text-align: right;\r\n}\r\n\r\n/* Детали маршрута */\r\n.routeDetails {\r\n  flex: 1;\r\n  padding: 20px;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Таблица квитанций */\r\n.dispatcherReceiptsTable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 10px;\r\n  background: white;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n}\r\n\\ n.dispatcherReceiptsTable th,\r\n.dispatcherReceiptsTable td {\r\n  border: 1px solid #ddd;\r\n  padding: 10px;\r\n  text-align: center;\r\n}\r\n\r\n.dispatcherReceiptsTable th {\r\n  background-color: var(--primary-color);\r\n  color: white;\r\n  cursor: pointer;\r\n  transition: background 0.2s ease-in-out;\r\n}\r\n\r\n.dispatcherReceiptsTable th:hover {\r\n  background: #0056b3;\r\n}\r\n\r\n.statusSelect {\r\n  width: 100%;\r\n  min-width: 120px;\r\n  white-space: nowrap;\r\n  background: transparent;\r\n  border: none;\r\n  color: white;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  appearance: none;\r\n  outline: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.statusSelect option {\r\n  color: #333;\r\n  background: #fff;\r\n}\r\n\r\n.statusSelect::-ms-expand {\r\n  display: none;\r\n}\r\n\r\n/* Мобильная адаптация */\r\n@media (max-width: 768px) {\r\n  .dispatcherContainer {\r\n    flex-direction: column;\r\n    height: auto;\r\n  }\r\n\r\n  .dispatcherSidebar {\r\n    width: 100%;\r\n    max-height: 40vh;\r\n    box-shadow: none;\r\n    padding: 10px;\r\n    background: #fff;\r\n  }\r\n\r\n  .routesList {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 5px;\r\n    white-space: nowrap;\r\n    padding: 10px 0;\r\n    overflow-y: auto;\r\n  }\r\n\r\n  .routeItem {\r\n    background: #f1f1f1;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  .routeDetails {\r\n    padding: 15px;\r\n  }\r\n\r\n  .dispatcherReceiptsTable {\r\n    display: block;\r\n    width: 100%;\r\n    overflow-x: auto;\r\n  }\r\n\r\n  .dispatcherReceiptsTable thead {\r\n    display: none;\r\n  }\r\n\r\n  .dispatcherReceiptsTable tbody {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n\r\n  .dispatcherReceiptsTable tr {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 10px;\r\n    background: white;\r\n    border: 1px solid #ddd;\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .dispatcherReceiptsTable td {\r\n    border: none;\r\n    text-align: left;\r\n    padding: 5px 0;\r\n  }\r\n\r\n  .dispatcherReceiptsTable td:first-child {\r\n    font-weight: bold;\r\n  }\r\n}\r\n\r\n/* Добавьте в самый конец файла ViewRoutes.module.css */\r\n\r\n.columnSettings {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;              /* расстояние между чекбоксами */\r\n  margin: 16px 0;       /* отступ от других блоков */\r\n  align-items: center;  /* выровнять по базовой линии */\r\n}\r\n\r\n.columnSettings label {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;          /* чуть больше пространства между чекбоксом и текстом */\r\n  white-space: nowrap;  /* не даёт переносить текст внутри лейбла */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dispatcherContainer": `RoutesDetails_dispatcherContainer__Lmf1G`,
	"dispatcherSidebar": `RoutesDetails_dispatcherSidebar__VUZ0M`,
	"dispatcherDateFilterRow": `RoutesDetails_dispatcherDateFilterRow__cm2mJ`,
	"routesList": `RoutesDetails_routesList__JbTlS`,
	"routeItem": `RoutesDetails_routeItem__JAQaF`,
	"selected": `RoutesDetails_selected__Bj0xZ`,
	"progressContainer": `RoutesDetails_progressContainer__hFOhJ`,
	"progressBar": `RoutesDetails_progressBar__RAOiO`,
	"progressDelivered": `RoutesDetails_progressDelivered__3rGRd`,
	"progressInProgress": `RoutesDetails_progressInProgress__RpwaB`,
	"progressUndelivered": `RoutesDetails_progressUndelivered__WWu9B`,
	"statusText": `RoutesDetails_statusText__4xVzm`,
	"routeDetails": `RoutesDetails_routeDetails__j25-M`,
	"dispatcherReceiptsTable": `RoutesDetails_dispatcherReceiptsTable__+3uPy`,
	"statusSelect": `RoutesDetails_statusSelect__3qt5Q`,
	"columnSettings": `RoutesDetails_columnSettings__Nltqw`
};
export default ___CSS_LOADER_EXPORT___;
